import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Form,
  Input,
  Radio,
  Typography,
  Table,
  Space,
  notification,
  Modal,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import jsonSpanish from '../../../lang/es/capituloV.json';
import jsonEnglish from '../../../lang/en/chapterV.json';

import { get, patch } from '../../../api/modules/answers';
import { getAllByAnswer } from '../../../api/modules/answerPolicies';

import LoadingModal from '../../../components/LoadingModal';

import INTERNAL_LINKS from '../../../enum/InternalLinks';
import FORM_MESSAGES from '../../../enum/FormMessages';

const { Title, Paragraph } = Typography;
const { confirm } = Modal;

const PollChapterV = ({ history, match }) => {
  const [form] = Form.useForm();
  const [lang] = useState(match.params.lang);
  const [fileLang, setFileLang] = useState(jsonEnglish);
  const [policiesData, setPoliciesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusForm, setStatusForm] = useState(0);
  const [requiredItems, setRequiredItems] = useState(false);
  const [answer, setAnswer] = useState({});

  const columnsPolicies = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: 300
    },
    {
      title: lang === "en" ? "Policy" : "Politica",
      dataIndex: "q16_a",
      key: "q16_a",
    },
    {
      title: lang === "en" ? "Actions" : "Acciones",
      dataIndex: "id",
      key: "id",
      width: 100,
      render: (text, record) => {
        return (<Button type="primary"><Link to={`${INTERNAL_LINKS.POLL_POLICIES}/${match.params.id}/${lang}/${record.id}`}>{lang === 'en' ? 'Edit' : 'Editar'}</Link></Button>);
      }
    }
  ];

  useEffect(() => {
    load();

    if (lang === 'en') {
      setFileLang(jsonEnglish);
    } else if (lang === 'es') {
      setFileLang(jsonSpanish);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = async () => {
    await Promise.all([
      getAnswer(),
      getByAnswer(),
    ]);
  }

  const getAnswer = async () => {
    let response = await get(match.params.id);
    setAnswer(response.data);
    form.setFieldsValue(response.data);
  };

  const getByAnswer = async () => {
    let response = await getAllByAnswer(match.params.id);
    setPoliciesData(response.data.results);
  }

  const save = async (data) => {
    setLoading(true);
    try {
      data["status_v"] = statusForm;
      await patch(match.params.id, data);
      notification.open({
        message: 'Successful transaction / Transacción exitosa ',
        duration: 2,
        placement: "bottomRight"
      });
      history.push(`${INTERNAL_LINKS.POLL_HOME}/${match.params.id}`);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const confirmClose = async (status) => {
    confirm({
      title: lang === 'en' ? 'Are you sure you want to CLOSE the chapter? If you do so, you will not be able to edit information later.' : '¿Está seguro de CERRAR el capítulo? Si lo hace no podrá editar información posteriormente.',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        setStatusForm(status);
        if(status === 1) {
          setRequiredItems(false);
        } else if(status === 2) {
          setRequiredItems(true);
        }
        form.submit();
      },
      onCancel() {
        setStatusForm(0);
        setRequiredItems(false);
        form.submit();
      },
    });
  };

  return (<div>
    {
      lang === 'en' ?
        <>
          <Title level={3}>PART V: DEVELOPMENT OF PUBLIC POLICIES AND GOOD PRACTICES</Title>
          <Paragraph>Can you choose one or two public policies (programs, projects or initiatives) issues that are already being implemented in your locality and that in your opinion are the most relevant or you consider important to in the attention to migrants or refugees.</Paragraph>
        </>
        :
        <>
          <Title level={3}>PARTE V: DESARROLLO DE POLÍTICAS PÚBLICAS Y BUENAS PRÁCTICAS</Title>
          <Paragraph>Por favor elija uno o dos políticas públicas (programas, proyectos o iniciativas) que ya se estén implementando en su localidad y que en su opinión sean las más relevantes o considere importantes para la atención a los migrantes o refugiados.</Paragraph>

        </>
    }

    <Form
      form={form}
      layout="vertical"
      onFinish={(data) => {
        save(data);
      }}
      validateMessages={FORM_MESSAGES[`validateMessages${lang.toUpperCase()}`]}
      scrollToFirstError={true}
    >
      <Form.Item
        label={`${lang === "en" ? "Questions" : "Preguntas"} 16 a 18`}
      >
        <Button type="primary">
          <Link to={`${INTERNAL_LINKS.POLL_POLICIES}/${match.params.id}/${lang}/`}>
            {lang === 'en' ? 'Add Policy' : 'Agregar Politica'}
          </Link>
        </Button>
        <br></br>
        <br></br>
        <Table columns={columnsPolicies} dataSource={policiesData}></Table>
      </Form.Item>
      <Form.Item
        label="19."
      ></Form.Item>
      <Form.Item
        label={fileLang.q19.a.text}
        name="q19_a"
        rules={[{ required: requiredItems }]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item
        label={fileLang.q19.b.text}
        name="q19_b"
        rules={[{ required: requiredItems }]}
      >
        <Radio.Group>
          {
            fileLang.q19.b.options.map(item => { return (<Radio key={`radio-q19-b-key-${item.value}`} value={item.value}>{item.text}</Radio>); })
          }
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label={fileLang.q19.b.explainText}
        name="q19_b_explain"
        rules={[{ required: requiredItems }]}
      >
        <Input.TextArea rows={4}></Input.TextArea>
      </Form.Item>
      <Form.Item
        label={fileLang.q19.c.text}
        name="q19_c"
        rules={[{ required: requiredItems }]}
      >
        <Radio.Group>
          {
            fileLang.q19.c.options.map(item => { return (<Radio key={`radio-q19-c-key-${item.value}`} value={item.value}>{item.text}</Radio>); })
          }
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label={fileLang.q19.c.explainText}
        name="q19_c_explain"
        rules={[{ required: requiredItems }]}
      >
        <Input.TextArea rows={4}></Input.TextArea>
      </Form.Item>
      <Form.Item
        label={lang === "en" ? "Observations" : "Observaciones"}
        name="comments_v"
      >
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item>
        <Space>
          {
            answer.status_v < 2 &&
            <>
              <Button loading={loading} type="primary" onClick={() => { setStatusForm(0); setRequiredItems(false); }} htmlType="submit">{lang === 'en' ? 'Save (pending)' : 'Guardar (parcial)'}</Button>
              <Button loading={loading} type="primary" onClick={() => { confirmClose(1); }}>{lang === 'en' ? 'Close (unfinished)' : 'Cerrar (Parcial)'}</Button>
              <Button loading={loading} type="primary" onClick={() => { confirmClose(2); }}>{lang === 'en' ? 'Close' : 'Cerrar'}</Button>
            </>
          }
          <Button type="link"><Link to={`${INTERNAL_LINKS.POLL_HOME}/${match.params.id}`}>{lang === 'en' ? 'Back' : 'Volver'}</Link></Button>
        </Space>
      </Form.Item>
    </Form>
    <LoadingModal loading={loading} lang={lang}></LoadingModal>
  </div>);
};

export default PollChapterV;